<template>
  <BaseModalEditCreate
    mode="add"
    :is-modified="false"
    :close-on-outside-click="false"
    max-width="extra"
    @dismiss-changes="emit('close')"
    @save="emitSelectedRows = true">
    <template #form>
      <div class="overflow-hidden h-full grid grid-rows-[auto_1fr]">
        <div class="font-light">{{ $t('messages.info.ctrlClickToAddItems') }}</div>
        <div class="w-full h-full overflow-x-hidden">
          <BaseTable
            v-if="list"
            table-id="range-items-materials-table"
            :total-records="totalRecords"
            :headers="materialAlterCodeHeaders"
            :list="list"
            :emit-selected-rows="emitSelectedRows"
            only-search
            hide-multiselect-delete
            hide-multiselect-download
            @refresh-data="onRefreshData"
            @selected-rows="onMultiselect" />
        </div>
      </div>
    </template>
    <template #saveButtonText> {{ $t('common.actions.add') }} </template>
  </BaseModalEditCreate>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import BaseModalEditCreate from '../common/BaseModalEditCreate.vue';
import BaseTable from '../common/BaseTable.vue';
import type { MaterialAlterCode } from '@/types/Materials';
import type { TableFilterData } from '@/types/Base';
import { useI18n } from 'vue-i18n';

defineProps<{
  list: MaterialAlterCode[];
  totalRecords?: number;
}>();

const emit = defineEmits(['close', 'refreshData', 'multiSelect']);

const { t: $t } = useI18n({ useScope: 'global' });
const materialAlterCodeHeaders = [
  { value: 'alterCode.name', text: $t('baseObject.name'), type: 'text', active: true },
  { value: 'alterCode.code', text: $t('baseObject.code'), type: 'text', active: true },
  { value: 'shortCode', text: $t('material.smallCode'), type: 'text', active: true },
  { value: 'isActive', text: $t('baseObject.isActive'), type: 'check', active: true },
];

function onRefreshData(data: TableFilterData) {
  data.sortColumn = data.column ? materialAlterCodeHeaders[data.column].value : '';
  emit('refreshData', data);
}

const emitSelectedRows = ref(false);
function onMultiselect(items: MaterialAlterCode[]) {
  emit('multiSelect', items);
}
</script>
